<template>
  <div id="main">

    <div id="header" class="fixed-top d-flex align-items-center">
      <label class="float-end label-tasks">{{onTasks}}</label>
    </div>

    <div id="camera" class="upper_info">
      <BarcodeReader
        ref="barcodeTag"
        @inputedBarcode="inputedBarcode"
      ></BarcodeReader>
    </div>

    <div id="footer" class="fixed-bottom d-flex align-items-center">
        <div class="dropdown option_menu d-flex align-items-center">
          <img class="points dropdown-toggle img-fluid" data-bs-toggle="dropdown" aria-expanded="false" src="@/assets/points.jpeg">
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li @click.prevent="showEditor()" ><a class="dropdown-item" href="#">直接入力する</a></li>
          </ul>
      </div>

      <div id="isbn" class="center-block d-flex align-items-center">
        <span class="span-isbn10">棚番号{{shelfBarcode}}</span>
      </div>

      <div id="closed" class="d-flex align-items-center">
        <span class="span-closed rounded" @click="clickedClosedSign()">完了</span>
      </div>
    </div>

    <div id="info" class="lower_info">

      <div class="info-left center-block">
        <div class="grid-table-scroll">
          <table class="table table-striped table-sm table-hover sticky_table">
            <thead>
              <tr class="col-header-shelf-number">
                <th @click="clickedDebug()">管理番号</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rowItem, rowIndex) in items"
                v-bind:key="rowIndex"
                v-bind:id = "'list' + rowItem.json.index"
                >
                <td class="col-shelf-number">{{rowItem.json.managed_id}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="info-right">

        <div class="container" v-show="isShowEditor">
          <div class="row input">
            <div class="col">
              <label>{{editorLabel}}</label>
            </div>
          </div>
          <div class="row input_pos">
            <div class="col">
              <input class="input-area form-control" type="text" v-model="directBarcode" :class="validBarcodeClass" @input="inputedValidBarcode()">
            </div>
          </div>
          <div class="row input_pos">
            <div class="col"><button type="button" class="btn btn-primary button-area" @click="registeBarcode()">登録</button></div>
            <div class="col"><button type="button" class="btn btn-secondary button-area" @click="showEditor()">キャンセル</button></div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import BarcodeReader from '@/components/barcordReader.vue'
import SoundEffect from '@/js/soundEffect.js'

export default defineComponent({
  components: {
    BarcodeReader
  },
  setup () {
    const router = useRouter()
    const items = ref([])
    const se1 = ref(new SoundEffect(require('@/assets/barcode1.mp3')))
    const se2 = ref(new SoundEffect(require('@/assets/barcode2.mp3')))
    const shelfNumber = ref('')
    const shelfBarcode = ref('')

    const debugTimer = ref()
    const debugReadCnt = ref([])

    const directBarcode = ref('')
    const invalidBarcode = ref(false)
    const isShowEditor = ref(false)

    const barcodeTag = ref()

    const testCamera = ref(false)

    onMounted(() => {
      debugTimer.value = new Date().getTime()
      console.log(shelfBarcode.value)
    })

    onUnmounted(() => {
    })

    const funcToListSite = () => {
      router.push({ name: 'PutupList' })
    }

    const inputedBarcode = (res) => {
      const tmpTimer = new Date().getTime()
      debugReadCnt.value.push({ time: Math.floor((tmpTimer - debugTimer.value) / 1000), barcord: res.value })

      // 8文字以上ならば商品バーコード
      if (res.value.substr(0, 1) !== 'Y') {
        if (shelfBarcode.value === '') {
          se2.value.play()
          alert('棚番号を登録してください')
        } else {
          se1.value.play()
          // console.log(shelfBarcode.value)
          // alert('棚番号:' + shelfBarcode.value + '管理番号' + res.value)
          axios.post('/api/putup/regist_shelf_id', { managed_id: res.value, shelf_id: shelfBarcode.value })
            .then((response) => {
              items.value = response.data
            })
          directBarcode.value = ''
        }
      } else {
        // 棚番号バーコード
        se1.value.play()
        if (shelfBarcode.value === '') {
          shelfBarcode.value = res.value
          directBarcode.value = ''
          // 棚番号の登録商品更新
          updateShelfRecords()
        } else {
          if (shelfBarcode.value === res.value) {
            directBarcode.value = ''
            shelfBarcode.value = ''
          } else {
            const response = window.confirm('別の棚番号が入力されました\n' + res.value + '\n変更してもよろしいですか?')
            if (response) {
              shelfBarcode.value = res.value
              directBarcode.value = ''
              // 棚番号の登録商品更新
              updateShelfRecords()
            }
          }
        }
      }
    }

    // 棚番号の登録商品更新
    const updateShelfRecords = () => {
      // 棚番号が入力されているならば
      if (shelfBarcode.value !== '') {
        axios.post('/api/get_records_from_shelf', { shelf_id: shelfBarcode.value })
          .then((response) => {
            items.value = response.data
          })
      }
    }

    const clickedClosedSign = () => {
      funcToListSite()
    }

    const clickedDebug = () => {
      let buf = ''
      debugReadCnt.value.forEach((x) => {
        buf += String(x.time) + ':' + x.barcord + '\n'
      })
      testCamera.value = !testCamera.value
      alert(buf)
    }

    const inputedValidBarcode = () => {
      const buf = directBarcode.value
      // 入力validation
      if (buf.match(/^[-()A-Za-z0-9]*$/)) {
        invalidBarcode.value = false
      } else {
        invalidBarcode.value = true
      }
    }

    const registeBarcode = () => {
      if (invalidBarcode.value) {
        alert('半角文字を入力してください')
      } else {
        // 通常どおり登録開始
        inputedBarcode({ value: directBarcode.value })
      }
    }

    const validBarcodeClass = computed(() => {
      let res = {}
      if (invalidBarcode.value) { res = { 'is-invalid': true } }
      return res
    })

    const editorLabel = computed(() => {
      let buf = ''
      // 棚番号なしならば
      if (shelfBarcode.value === '') {
        buf = '棚番号を入力してください'
      } else {
        buf = '管理番号を入力してください'
      }
      return buf
    })

    const showEditor = () => {
      isShowEditor.value = !isShowEditor.value
    }

    const showCamera = () => {
      testCamera.value = !testCamera.value
    }
    return {
      shelfNumber,
      clickedClosedSign,
      inputedBarcode,
      items,
      shelfBarcode,
      clickedDebug,
      directBarcode,
      inputedValidBarcode,
      validBarcodeClass,
      registeBarcode,
      showEditor,
      isShowEditor,
      editorLabel,
      barcodeTag,
      showCamera,
      testCamera
    }
  }
})
</script>
<style lang="scss" scoped>

#main {
  height: 100%;
  width: 100%;
  font-size: medium;

  #header {
    top: 0;
    position: fixed;
    height: 5vh;
    width: 100%;
    background: #47695E;
    color: white;
    font-weight: bold;
    font-size: large;

    img.back {
      object-fit: cover;
      position: absolute;
      left: 2vw;
      height: 90%;
    }
    label.label-number {
      position: absolute;
      left: 15vw;
    }
    label.label-tasks {
      position: absolute;
      right: 15vw;
    }
    img.next {
      object-fit: cover;
      position: absolute;
      right: 2vw;
      height: 90%;
    }
  }

  #footer {
    position: fixed;
    top : 45vh;
    height: 5vh;
    width: 100%;
    color: #47695E;
    font-weight: bold;
    font-size: large;
    background: #e9edeb;

    .option_menu {
      height: 100%;
      img.points {
        position: relative;
        left: 0;
        height: 80%;
        object-fit: cover;
        mix-blend-mode: multiply;
      }
    }

    #isbn {
      height: 100%;
      margin-left: auto;
      margin-right: auto;
      img.barcord {
        position: relative;
        margin-right: 2vw;
        height: 80%;
        object-fit: cover;
      }
      span.span-isbn10 {
        bottom: auto;
        left: 0;
        right: 0;
      }
    }

    #closed {
      position: absolute;
      height: 100%;
      right: 1rem;
      span.span-closed {
        bottom: auto;
        left: 0;
        right: 0;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        background: #47695E;
        color: white;
      }
    }
  }

  .upper_info {
    position: fixed;
    top : 5vh;
    height: 40vh;
    width: 100%;
  }

  .lower_info {
    display: flex;
    position: fixed;
    top: 50vh;
    height: 40vh;
    width: 100%;
  }

  #info {
    .info-left {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 40%;
    }
    .info-left div.div-cm {
      position: relative;
      top: 0;
      height: 6vh;
      width: 100%;
    }
    .info-right {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 60%;

      .input_pos {
        margin-top: 1.5rem;
      }

    .col-header-shelf-number {
      color: #47695E;
      font-weight: bold;
      font-size: large;
      background: #e9edeb;
    }

    }
    img.img-arrow {
      position: relative;
      height: 6vh;
      object-fit: contain;
    }
    .info-left div.div-img {
      position: relative;
      top: 0;
      height: 28vh;
      width: 100%;
    }
    label.label-cm {
      margin-left: 1rem;
      font-weight: bold;
    }
    img.image-size {
      height: 100%;
      object-fit: contain;
    }

    div.div-sku {
      width: 100%;
      height: 100%;

      .same-item-warning {
        position: relative;
        padding-left: 1vw;
        margin-left: 2vw;
        font-size: small;
        font-weight: bold;
        color: red;
      }

      .span-sku {
        width: 50%;
        margin-top: 2px;
        position: relative;
        padding-left: 1vw;
        padding-right: 1vw;
        margin-left: 2vw;
        font-size: large;
        font-weight: bold;
        background: #47695E;
        color: white;
      }

      .span-count {
        position: relative;
        padding-left: 1vw;
        margin-left: 2vw;
        font-size: small;
        font-weight: bold;
        color: red;
      }
    }

    span.span-name {
      height: 100%;
      width: 100%;
      margin-top: 1rem;
      margin-left: 1rem;
      font-size: large;
      font-weight: bold;
    }
  }
}

</style>
